import config from "config";
import cdn from "cdnImagePreprocessor";
import validPath from "is-valid-path";

export default [
  '$window', '$rootScope', '$state', '$cookies', '$timeout', '$location', 'CartService', 'AuthService', 'MarketplaceService', 'UserDataService', 'FacebookLoginService',
  class HeaderController {
    constructor($window, $rootScope, $state, $cookies, $timeout, $location, CartService, AuthService, MarketplaceService, UserDataService, facebook) {
      this._$window = $window;
      this._$rootScope = $rootScope;
      this._$state = $state;
      this._$cookies = $cookies;
      this._$timeout = $timeout;
      this._$location = $location;
      this._authService = AuthService;
      this._marketplaceService = MarketplaceService;
      this.userDataService = UserDataService;
      this._facebook = facebook;
      this.cart = CartService;
      this.cartDropdownOpen = false;
      this.showSearch = false;
      this.blurTimeout = null;
      this.validated = this._$location.search().email_validated;

      if (this._$location.path() === '/client-logout') {
        this.logout().then(() => {
          this._$state.go('home', {}, { location: 'replace' })
          this._loginCheck();
        });
      } else {
        this._loginCheck();
      }

      this._initPartnershipEvents();
      this._initScrollEvent();
    }

    _loginCheck() {
      let loginCheck = this._checkIfUserLoggedIn();
      // let fbLoginCheck = this._facebook.getLoggedInUser();
      let returnPath = this._$location.search().return,
        route = typeof returnPath == 'string' && validPath(returnPath.split('?')[0]) ? returnPath.replace(/\\/g, '').replace('//', '') : '/client';

      loginCheck
        .then((res) => {
          if (res.user.roles === 'COBRAND-ADMIN' && $state.current.name.indexOf('cobrand-admin') === -1) {
            $window.location.href = '/cobrand-admin';
          }
        })
        .catch(() => {
          // fbLoginCheck
          //   .then((res) => this._facebookLogin(res))
          //   .catch(() => {
          //     if (this._$location.path() === '/login') this.showLogin(route);
          //   });

          switch (this._$location.path()) {
            case '/login':
              this.showLogin(route, this._$location.search()['email']);
              break;
            case '/register':
              this.showRegister();
              break;
            case '/forgot-password':
              this._$rootScope.$broadcast('login:forgotPassword');
              break;
          }
        });
    }

    onSalesFlow() {
      return this._$state.includes('sales');
    }

    onProductDetails() {
      return this._$state.current.name === 'sales-store';
    }

    performSearch() {
      if (this.search) {
        this._$window.location.href = `/marketplace/?search=${this.search}`;
      } else {
        this._$window.location.href = `/marketplace`;
      }
      this.redirecting = true;
    }

    handleKeydown(event) {
      if (event.keyCode === 27) {
        this.showSearch = false;
        this.search = '';
        this.showSearchSuggestions = false;
        this.searchSuggestions = null;
      }
    }

    navigateToDashboard() {
      if (this.userDataService.userLoggedIn()) {
        this.redirecting = true;
        this._checkIfUserLoggedIn()
          .then((res) => {
            let route;

            if (res.user.roles === 'CUSTOMER') route = '/my-account';
            else if (res.dashboard_link) route = res.dashboard_link;
            else route = '/client';

            this._$window.location.href = route;
          })
          .catch((err) => {
            this.showLogin('/client');
            this.redirecting = false;
          });
      } else this.showLogin('/client');
    }

    launchDesigner() {
      if (this.gravatar()) {
        this.redirecting = true;
        this._checkIfUserLoggedIn()
          .then((res) => this._$window.location.href = '/design.beta')
          .catch((err) => {
            this.showLogin('/design.beta');
            this.redirecting = false;
          });
      } else this.showLogin('/design.beta');
    }

    logout() {
      this.redirecting = true;
      this._facebook.logout();
      this.showMenu = false;
      this._$rootScope.$broadcast('menu-toggle', {
        canScroll: true
      });

      return this._authService.logout()
        .finally(() => {
          this.userDataService.clearUserData();
          this.redirecting = false;

          if (this._$state.includes('my-account')) {
            this._$window.location.href = '/';
          }
          this._$rootScope.$broadcast('logout:success');
        });
    }

    showLogin(route, email) {
      this._$rootScope.$broadcast('register:close');
      this._$rootScope.$broadcast('login:open', { route, email });
    }

    showRegister() {
      this._$rootScope.$broadcast('login:close');
      this._$rootScope.$broadcast('register:open', {});
    }

    searchChanged() {
      if (!this.search || typeof this.search == 'string' && this.search.length == 0) {
        // Clear search suggestions without calling the API.
        this.searchSuggestions = null;
        return;
      }

      this._marketplaceService.suggest(this.search)
        .then(res => {
          this.searchSuggestions = res.results.length ? res.results : null;
        })
        .catch(() => this.searchSuggestions = null);
    }

    searchBlur() {
      this._$timeout.cancel(this.blurTimeout);
      this.blurTimeout = this._$timeout(() => {
        if (!this.suggestionFocused) {
          this.showSearchSuggestions = false;
          this.showSearch = false;
        }
      }, 200);
    }

    searchFocus() {
      this.showSearchSuggestions = true;
      this.showSearch = true;
    }

    focusSuggestion(e) {
      this.suggestionFocused = true;
    }

    blurSuggestion(e) {
      if (!$(':focus').closest('vs-search-suggest').length) {
        this.suggestionFocused = false;
        this.showSearchSuggestions = false;
        this.showSearch = false;
      }
    }

    toggleMenu() {
      this.showMenu = !this.showMenu;
      this._$rootScope.$broadcast('menu-toggle', {
        canScroll: !this.showMenu
      });
    }

    toggleSlideMenu(toggle) {
      let showSlideMenu = typeof toggle !== 'undefined' ? toggle : !this.showSlideMenu;

      this.showSlideMenu = showSlideMenu;
      this._$rootScope.$broadcast('slide-menu-toggle', {
        canScroll: !this.showSlideMenu
      });
    }

    isScrolled() {
      return (this._$window.scrollY > 0);
    }

    _checkIfUserLoggedIn() {
      let promise = this._authService.getCurrentUser();

      promise.then((res) => this.userDataService.setUserData(res))
        .catch((err) => this.userDataService.clearUserData());

      return promise;
    }

    _facebookLogin(res) {
      let promise = this._authService.socialLogin('facebook', res.authResponse.accessToken, res.authResponse.userID, 'CLIENT');

      promise.then((res) => this.userDataService.setUserData(res))
        .catch((err) => this.userDataService.clearUserData());

      return promise;
    }

    _initPartnershipEvents() {
      this._$rootScope.$on('partnership:showLogo', (e, args) => {
        this.partnershipLogoPath = cdn(config).asset(`/${args.pid}.png`);
      });
    }

    _initScrollEvent() {
      let timeout = null; // Use the timeout to slow down the digests.
      angular.element(this._$window).bind("scroll", () => {
        if (timeout === null) timeout = this._$timeout(() => {
          timeout = null;
          this._$rootScope.$apply();
        }, 100);
      });
    }
  }
];


// WEBPACK FOOTER //
// ./source/client/layout-components/header/header.ctrl.js